'use es6';

import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import UITag from 'UIComponents/tag/UITag';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { BY_PRODUCT as FEATURES_BY_PRODUCT } from 'ecosystem-marketplace-core/constants/groupTags/hubspotFeatures';
import { getHubSpotFeatureI18nKey, getHubSpotFeatureGroupI18nKey } from 'marketplace-ui-common/utils/i18n';
import { HUBSPOT_FEATURES } from '../../../constants/search/FilterKey';
import { hubspotFeature as hubspotFeaturePropType } from '../../../constants/PropTypes';
import { getIsUngatedForContentHub } from '../../../selectors/auth';
import FilterTag from './FilterTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const featuresMap = Immutable.OrderedMap({
  CRM: FEATURES_BY_PRODUCT.CRM,
  MARKETING: FEATURES_BY_PRODUCT.MARKETING,
  SALES: FEATURES_BY_PRODUCT.SALES,
  SERVICE: FEATURES_BY_PRODUCT.SERVICE,
  CMS: FEATURES_BY_PRODUCT.CMS,
  OPS: FEATURES_BY_PRODUCT.OPS
});
const HubSpotFeaturesGroup = ({
  groupKey,
  hubspotFeatures,
  getFilterLink,
  isPreview,
  isUngatedForContentHub
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("span", {
    className: "is--heading-7 m-top-2 m-bottom-2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getHubSpotFeatureGroupI18nKey(groupKey, isUngatedForContentHub)
    })
  }), hubspotFeatures.map(hubspotFeature => [hubspotFeature, getHubSpotFeatureI18nKey(hubspotFeature)]).sort(([__, hubspotFeatureAI18nKey], [___, hubspotFeatureBI18nKey]) => {
    return localeComparator(unescapedText(hubspotFeatureAI18nKey), unescapedText(hubspotFeatureBI18nKey));
  }).map(([hubspotFeature, hubspotFeatureI18nKey]) => {
    return /*#__PURE__*/_jsx(UIRouterLink, {
      disabled: isPreview,
      to: getFilterLink(HUBSPOT_FEATURES, hubspotFeature, true),
      children: /*#__PURE__*/_jsx(FilterTag, {
        children: /*#__PURE__*/_jsx(UITag, {
          className: "m-left-0 m-right-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: hubspotFeatureI18nKey
          })
        })
      })
    }, hubspotFeature);
  })]
});
const HubSpotFeatures = ({
  hubspotFeatures,
  getFilterLink,
  isPreview
}) => {
  const isUngatedForContentHub = useSelector(getIsUngatedForContentHub);
  const filteredFeatures = useMemo(() => featuresMap.map(allFeaturesForProduct => hubspotFeatures.filter(flatFeature => allFeaturesForProduct[flatFeature])).filter(features => !!features.length), [hubspotFeatures]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: filteredFeatures.map((features, groupKey) => /*#__PURE__*/_jsx(HubSpotFeaturesGroup, {
      groupKey: groupKey,
      hubspotFeatures: features,
      getFilterLink: getFilterLink,
      isPreview: isPreview,
      isUngatedForContentHub: isUngatedForContentHub
    }, groupKey)).toArray()
  });
};
HubSpotFeatures.propTypes = {
  hubspotFeatures: PropTypes.arrayOf(hubspotFeaturePropType).isRequired,
  getFilterLink: PropTypes.func.isRequired,
  isPreview: PropTypes.bool.isRequired
};
export default HubSpotFeatures;